import { Component, computed, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { GermanNumberPipe } from '../../../../shared/pipes/german-number-pipe';
import { PriceFilter } from '../../stores/price.store';
import { PriceConversionService } from '../../services/price-conversion.service';

@Component({
  selector: 'app-analysis-price-graph-tooltip',
  templateUrl: './analysis-price-graph-tooltip.html',
  imports: [DatePipe, GermanNumberPipe, TranslocoPipe],
})
export class AnalysisPriceGraphTooltip {
  private priceConversionService = inject(PriceConversionService);

  date = input<Date>();
  price = input<number>();
  isPrognosis = input(false);
  lowerEstimate = input<number>();
  upperEstimate = input<number>();
  granularity = input<PriceFilter['granularity']>();
  showEurMwh = input(false);
  comparisonPrice = input<number>();
  comparisonYear = input<number | string>();

  protected displayPrice = computed(() => {
    const p = this.price();
    return p !== undefined
      ? this.priceConversionService.convertPrice(p, this.showEurMwh())
      : undefined;
  });
  protected displayComparisonPrice = computed(() => {
    const cp = this.comparisonPrice();
    return cp !== undefined
      ? this.priceConversionService.convertPrice(cp, this.showEurMwh())
      : undefined;
  });
  protected displayLower = computed(() => {
    const v = this.lowerEstimate();
    return v !== undefined
      ? this.priceConversionService.convertPrice(v, this.showEurMwh())
      : undefined;
  });
  protected displayUpper = computed(() => {
    const v = this.upperEstimate();
    return v !== undefined
      ? this.priceConversionService.convertPrice(v, this.showEurMwh())
      : undefined;
  });
  protected unitKey = computed(() =>
    this.showEurMwh()
      ? 'cockpit.analysis.hpfc.detail.yAxisLabelEurMwh'
      : 'cockpit.analysis.hpfc.detail.yAxisLabel',
  );
}
